// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/InviteYourColleagueForm/Handlers/SetFieldValue";
import { InviteYourColleagueFormContext } from "@store/Library/Widgets/InviteYourColleague/InviteYourColleagueForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    fieldLabel = "fieldLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.fieldLabel]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    lastNameState: state.greif.components.inviteYourColleagueForm.fieldValues["lastName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface LastNameStyles {
    lastNameTextField?: TextFieldPresentationProps;
}

export const lastNameStyles: LastNameStyles = {};

const styles = lastNameStyles;

const LastName: FC<Props> = ({ fields, lastNameState, setFieldValue }) => {
    const { isRequired, fieldLabel } = fields;
    const inviteYourColleagueFormContext = useContext(InviteYourColleagueFormContext);
    const [lastNameErrorMessage, setLastNameErrorMessage] = useState("");
    const [lastName, setLastName] = useState("");
    const [hasValidated, setHasValidated] = useState(false);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.lastName = validateLastName;
    }, [lastName]);

    useEffect(() => {
        if (hasValidated) {
            validateLastName();
        }
    }, [lastName, hasValidated]);

    useEffect(() => {
        setLastName(lastNameState as string);
    }, [lastNameState]);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.lastName = validateLastName;
    }, [isRequired]);

    const validateLastName = (value: string = lastName) => {
        setHasValidated(true);
        const errorMessage = isRequired && !value ? siteMessage("Field_Required", fieldLabel).toString() : "";
        setLastNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const lastNameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setLastName(event.target.value);
        if (hasValidated) {
            validateLastName(event.target.value);
        }
    };

    const lastNameChangeOnBlur = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "lastName", value: event.target.value });
    };

    return (
        <TextField
            label={fieldLabel}
            value={lastName || ""}
            onChange={lastNameChangeHandler}
            required={isRequired}
            error={lastNameErrorMessage}
            onBlur={lastNameChangeOnBlur}
            data-test-selector="last-name-input"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(LastName),
    definition: {
        displayName: "Last Name",
        group: constants.widgetGroup.inviteYourColleague,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.inviteYourColleague, constants.pageType.notificationPreferences],
        fieldDefinitions: [
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Your Colleague's Last Name",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
